import Code from './code'

Code.install = vue => {
  vue.component(Code.name, Code)
}

export default Code
